// extracted by mini-css-extract-plugin
export default {"container":"hC-z","dimension":"iC-z","dimensionLabels":"jC-z"};